import "./home.scss";
import { Link } from "react-router-dom";
import logo from "../../assets/images/skytkd-white.png";
// import Park from "../Park/park";
// import Slider from "../Image Containers/Slider/slider";
import Scroller from "../Image Containers/Scroller/scroller";
import About from "../About/about";
import Trial from "../Trial/trial";
import Programs from "../Programs/programs";
import ScheduleTeaser from "../ScheduleTeaser/scheduleteaser";
import FirstVisit from "../FirstVisit/firstvisit";
import Reviews from "../Reviews/reviews";
import Youtube from "../Youtube/youtube";
// import Instagram from "../Instagram/instagram";
import Socials from "../Socials/socials";

// import Location from "../Location/location";

const Home = () => {
  return (
    <>
      <section className="top-section section home-section">
        <div className="container home-container">
          <div className="flex home-flex">
            <img src={logo} alt="logo" />
            <h1>SKY TAEKWONDO</h1>
            <h3>Martial Arts School</h3>
            <div className="grid location-grid">
              <div id="basking" className="location">
                <h1>Basking Ridge</h1>
                <h2>403 King George Rd, Basking Ridge, NJ 07920</h2>
              </div>
              <div id="clinton" className="location">
                <h1>Clinton</h1>
                <h2>114 W Main St, Clinton, NJ 08809</h2>
              </div>
            </div>
            <div className="hero-cta">
              <p className="hero-cta-text">
                25th Anniversary — First Class FREE · FREE uniform
                when you sign up after your trial
              </p>
              <div className="hero-cta-actions">
                <Link to="/#trial" className="hero-cta-primary">
                  Book My FREE Class
                </Link>
                <Link to="/#programs" className="hero-cta-secondary">
                  See Our Programs
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Trial />

      <Programs />

      <ScheduleTeaser />

      <FirstVisit />

      <Reviews />

      <About />

      {/* <Slider /> */}

      <Socials />

      {/* <Location /> */}

      <Youtube />

      {/* <Park /> */}

      <Scroller />

      {/* <Instagram /> */}
    </>
  );
};

export default Home;
